// extracted by mini-css-extract-plugin
export default {"image":"Movie_image__WTy9W"};